import React, { useEffect, useCallback, useState} from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {connect} from 'react-redux';

const PianoRollDropdown = ({setAutoScroll, autoScroll}) => { 
    let [toggled, setToggled] = useState(false);
    let onClickAutoScroll = useCallback(() => {
        setAutoScroll(!autoScroll);
    }, [setAutoScroll, autoScroll]);

    return (
        <div className="piano-roll-dropdown">
            <ButtonDropdown
              className="view-dropdown"
              show={toggled ? "true" : "false"}
              isOpen={toggled}
              toggle={() => setToggled(!toggled)}>
              <DropdownToggle size="sm" caret color="primary">
                <img className="piano-roll-actions" src="/automation-icon-disabled.png"/>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={onClickAutoScroll}
                  key=""
                  size="sm">
                  Auto-Scroll {autoScroll ?
                               <span className="small_checkmark">
                                 <div className="small_checkmark_stem"/>
                                 <div className="small_checkmark_kick"/>
                               </span> : ''}
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollDropdown);
